// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__33_qV","colCheckbox":"styles_colCheckbox__jqYuY"};